import React from 'react'
import PropTypes from 'prop-types'

// hixme-ui
import Button from '@hixme-ui/button'
import Container from '@hixme-ui/container'
import Icon from '@hixme-ui/icon'
import Text from '@hixme-ui/text'

const NoPlan = ({ onSelectPlan }) => (
  <Container
    rounded
    width="100%"
    height="500px"
    style={{ border: '2px dashed rgb(143, 157, 168)' }}
  >
    <Container textCenter noPadding>
      <Container noPadding margin="30px 0 20px 0">
        <Icon light heartOutline size={2} />
      </Container>
      <Text thin light medium center>
        Compare your 3 favorite plans.
      </Text>
      <Container>
        <Button onClick={onSelectPlan}>Select</Button>
      </Container>
    </Container>
  </Container>
)

NoPlan.propTypes = {
  onSelectPlan: PropTypes.func.isRequired,
}

export default NoPlan
